<template>
	<div v-loading="loading">
		<div id="wrap" class="fixed">
			<el-tabs v-model="activeName" @tab-click="handleClick">
				<el-tab-pane label="企业信息" name="first"></el-tab-pane>
				<el-tab-pane label="经济效益" name="second"></el-tab-pane>
				<el-tab-pane label="专业化程度" name="third"></el-tab-pane>
				<el-tab-pane label="创新能力" name="fourth"></el-tab-pane>
				<el-tab-pane label="经营管理" name="six"></el-tab-pane>
				<el-tab-pane label="资料生成" name="seven"></el-tab-pane>
			</el-tabs>
		</div>

		<div id="wrap2" style="margin-top: 70px" class="wrap_page">
			<div class="text">近两年经营情况</div>
			<div class="content">
				<div class="item flex flex-around">
					<div></div>
					<div>{{ param.zjtxAnnualOperatingConditionBO[0].annual }}年</div>
					<div>{{ param.zjtxAnnualOperatingConditionBO[1].annual }}年</div>
				</div>
				<div class="item flex flex-around">
					<div>营业收入</div>
					<div>
						<el-input
							placeholder="营业收入"
							onkeyup="value=value.replace(/[^\d.]/g,'')"
							v-model="param.zjtxAnnualOperatingConditionBO[0].taking"
						></el-input>
					</div>
					<div>
						<el-input
							placeholder="营业收入"
							onkeyup="value=value.replace(/[^\d.]/g,'')"
							v-model="param.zjtxAnnualOperatingConditionBO[1].taking"
						></el-input>
					</div>
				</div>
				<div class="item flex flex-around">
					<div>营业业务收入</div>
					<div>
						<el-input
							placeholder="营业业务收入"
							onkeyup="value=value.replace(/[^\d.]/g,'')"
							v-model="param.zjtxAnnualOperatingConditionBO[0].businessRevenue"
						></el-input>
					</div>
					<div>
						<el-input
							placeholder="营业业务收入"
							onkeyup="value=value.replace(/[^\d.]/g,'')"
							v-model="param.zjtxAnnualOperatingConditionBO[1].businessRevenue"
						></el-input>
					</div>
				</div>
				<div class="item flex flex-around">
					<div>主营业业务收入增长率</div>
					<div>
						<el-input
							placeholder="主营业务收入增长率"
							onkeyup="value=value.replace(/[^\d.]/g,'')"
							v-model="
								param.zjtxAnnualOperatingConditionBO[0]
									.mainBusinessRevenueGrowthRate
							"
						></el-input>
					</div>
					<div>
						<el-input
							placeholder="主营业务收入增长率"
							onkeyup="value=value.replace(/[^\d.]/g,'')"
							v-model="
								param.zjtxAnnualOperatingConditionBO[1]
									.mainBusinessRevenueGrowthRate
							"
						></el-input>
					</div>
				</div>
				<div class="item flex flex-around">
					<div>利润总额</div>
					<div>
						<el-input
							placeholder="利润总额"
							onkeyup="value=value.replace(/[^\d.]/g,'')"
							v-model="param.zjtxAnnualOperatingConditionBO[0].totalProfit"
						></el-input>
					</div>
					<div>
						<el-input
							placeholder="利润总额"
							onkeyup="value=value.replace(/[^\d.]/g,'')"
							v-model="param.zjtxAnnualOperatingConditionBO[1].totalProfit"
						></el-input>
					</div>
				</div>
				<div class="item flex flex-around">
					<div>净利润总额</div>
					<div>
						<el-input
							placeholder="净利润总额"
							onkeyup="value=value.replace(/[^\d.]/g,'')"
							v-model="param.zjtxAnnualOperatingConditionBO[0].totalNetProfit"
						></el-input>
					</div>
					<div>
						<el-input
							placeholder="净利润总额"
							onkeyup="value=value.replace(/[^\d.]/g,'')"
							v-model="param.zjtxAnnualOperatingConditionBO[1].totalNetProfit"
						></el-input>
					</div>
				</div>
				<div class="item flex flex-around">
					<div>净利润增长率</div>
					<div>
						<el-input
							placeholder="净利润增长率"
							onkeyup="value=value.replace(/[^\d.]/g,'')"
							v-model="
								param.zjtxAnnualOperatingConditionBO[0].netProfitGrowthRate
							"
						></el-input>
					</div>
					<div>
						<el-input
							placeholder="净利润增长率"
							onkeyup="value=value.replace(/[^\d.]/g,'')"
							v-model="
								param.zjtxAnnualOperatingConditionBO[1].netProfitGrowthRate
							"
						></el-input>
					</div>
				</div>
				<div class="item flex flex-around">
					<div>负债总额</div>
					<div>
						<el-input
							placeholder="负债总额"
							onkeyup="value=value.replace(/[^\d.]/g,'')"
							v-model="param.zjtxAnnualOperatingConditionBO[0].totalLiabilities"
						></el-input>
					</div>
					<div>
						<el-input
							placeholder="负债总额"
							onkeyup="value=value.replace(/[^\d.]/g,'')"
							v-model="param.zjtxAnnualOperatingConditionBO[1].totalLiabilities"
						></el-input>
					</div>
				</div>
				<div class="item flex flex-around">
					<div>资产总额</div>
					<div>
						<el-input
							placeholder="资产总额"
							onkeyup="value=value.replace(/[^\d.]/g,'')"
							v-model="param.zjtxAnnualOperatingConditionBO[0].totalAssets"
						></el-input>
					</div>
					<div>
						<el-input
							placeholder="资产总额"
							onkeyup="value=value.replace(/[^\d.]/g,'')"
							v-model="param.zjtxAnnualOperatingConditionBO[1].totalAssets"
						></el-input>
					</div>
				</div>
				<div class="item flex flex-around">
					<div>资产负债率</div>
					<div>
						<el-input
							placeholder="资产负债率"
							onkeyup="value=value.replace(/[^\d.]/g,'')"
							v-model="
								param.zjtxAnnualOperatingConditionBO[0].assetLiabilityRate
							"
						></el-input>
					</div>
					<div>
						<el-input
							placeholder="资产负债率"
							onkeyup="value=value.replace(/[^\d.]/g,'')"
							v-model="
								param.zjtxAnnualOperatingConditionBO[1].assetLiabilityRate
							"
						></el-input>
					</div>
				</div>
				<div class="item flex flex-around">
					<div>上缴税金</div>
					<div>
						<el-input
							placeholder="上缴税金"
							onkeyup="value=value.replace(/[^\d.]/g,'')"
							v-model="param.zjtxAnnualOperatingConditionBO[0].taxes"
						></el-input>
					</div>
					<div>
						<el-input
							placeholder="上缴税金"
							onkeyup="value=value.replace(/[^\d.]/g,'')"
							v-model="param.zjtxAnnualOperatingConditionBO[1].taxes"
						></el-input>
					</div>
				</div>
			</div>
		</div>

		<div id="wrap3" style="margin-top: 15px" class="wrap_page">
			<div class="text">近2年内是否获得新增股权融资</div>
			<el-form
				class="ruleForm flex flex-wrap"
				label-position="top"
				ref="ruleForm2"
				:rules="rules"
				:model="param"
			>
				<el-form-item prop="zjtxProjectBO.isNationalLevel" class="item">
					<span slot="label">
						<span class="span-box">
							<span>是否融资</span>
						</span>
					</span>
					<el-select
						v-model="param.zjtxProjectBO.isNationalLevel"
						placeholder="是"
					>
						<el-option
							v-for="item in options"
							:key="item.value"
							:label="item.label"
							:value="item.value"
						>
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item
					prop="name"
					class="item"
					v-show="param.zjtxProjectBO.isNationalLevel == 1"
				>
					<span slot="label">
						<span class="span-box">
							<span>融资金额</span>
						</span>
					</span>
					<el-input
						style="width:50%;"
						maxlength="18"
						v-model="param.zjtxProjectBO.financingAmount"
						placeholder="0"
						onkeyup="value=value.replace(/[^\d]/g,'')"
					></el-input>
				</el-form-item>
			</el-form>
		</div>

		<div class="flex flex-center" style="margin-top: 20px">
			<el-button type="primary" @click="save()">保存</el-button>
			<el-button type="primary" @click="reset()">重置</el-button>
			<el-button type="primary" @click="nextPage()">下一项</el-button>
		</div>
	</div>
</template>

<script>
import {
	getLastThreeYears,
	saveOperation,
	queryOperationInfo
} from "@/api/specialization";

export default {
	data() {
		return {
			rules: {
				"zjtxProjectBO.isNationalLevel": [
					{
						required: true,
						message: "请选择是否国家高新区内企业",
						trigger: "blur"
					}
				],
				"zjtxAnnualOperatingConditionBO[0].taking": [
					{
						required: true,
						message: "请输入数字",
						trigger: "blur"
					},
					{ pattern: /[1234567890.]/, message: "请输入数字", trigger: "blur" }
				]
			},
			loading: false,
			activeName: "second",
			value: 1,
			options: [
				{
					value: 1,
					label: "是"
				},
				{
					value: 2,
					label: "否"
				}
			],
			param: {
				zjtxAnnualOperatingConditionBO: [{ id: "" }, { id: "" }],
				zjtxProjectBO: {}
			}
		};
	},
	created() {
		if (sessionStorage.getItem("zt_special_id") != "undefined") {
			this.queryOperationInfo();
		} else {
			this.getLastThreeYears();
			console.log("++++");
		}
	},
	methods: {
		financingAmountInput() {
			console.log($("#inputLength"));
			// if($("#inputLength").length){
			//   this.$message.error('最大输入长度为20!');
			// }
		},
		reset() {
			this.param.zjtxProjectBO = { id: this.param.zjtxProjectBO.id };
			this.param.zjtxAnnualOperatingConditionBO = [
				{
					id: this.param.zjtxAnnualOperatingConditionBO[0].id,
					annual: this.param.zjtxAnnualOperatingConditionBO[0].annual
				},
				{
					id: this.param.zjtxAnnualOperatingConditionBO[1].id,
					annual: this.param.zjtxAnnualOperatingConditionBO[1].annual
				}
			];
		},
		queryOperationInfo() {
			this.loading = true;
			queryOperationInfo(sessionStorage.getItem("zt_special_id")).then(res => {
				console.log(res);
				this.loading = false;
				this.param.zjtxAnnualOperatingConditionBO =
					res.data.zjtxAnnualOperatingConditionBO;
				this.param.zjtxAnnualOperatingConditionBO[0].zjtxId = sessionStorage.getItem(
					"zt_special_id"
				);
				this.param.zjtxAnnualOperatingConditionBO[1].zjtxId = sessionStorage.getItem(
					"zt_special_id"
				);
				this.param.zjtxProjectBO = res.data.zjtxProjectBO;
				// console.log(this.param.zjtxAnnualOperatingConditionBO);
			});
		},
		nextPage() {
			this.$refs["ruleForm2"].validate(valid => {
				if (valid) {
					this.param.zjtxProjectBO.id = sessionStorage.getItem("zt_special_id");
					this.loading = true;
					saveOperation(this.param).then(res => {
						this.loading = false;
						if (res.code == "00000") {
							this.msgSuccess("操作成功");
							console.log(this.param.zjtxAnnualOperatingConditionBO[0].id);
							if (
									!this.param.zjtxAnnualOperatingConditionBO[0].id ||
									this.param.zjtxAnnualOperatingConditionBO[0].id.length != 32
							) {
								this.param.zjtxAnnualOperatingConditionBO[0].id =
										res.data.AnnualOperatingCondition0;
								this.param.zjtxAnnualOperatingConditionBO[1].id =
										res.data.AnnualOperatingCondition1;
							}
							this.$router.push("/centerform/specializationProfessionalization");
						}
					});
				}
			});
		},
		save() {
			this.$refs["ruleForm2"].validate(valid => {
				if (valid) {
					this.param.zjtxProjectBO.id = sessionStorage.getItem("zt_special_id");
					this.loading = true;
					saveOperation(this.param).then(res => {
						this.loading = false;
						if (res.code == "00000") {
							this.msgSuccess("操作成功");
							console.log(this.param.zjtxAnnualOperatingConditionBO[0].id);
							if (
								!this.param.zjtxAnnualOperatingConditionBO[0].id ||
								this.param.zjtxAnnualOperatingConditionBO[0].id.length != 32
							) {
								this.param.zjtxAnnualOperatingConditionBO[0].id =
									res.data.AnnualOperatingCondition0;
								this.param.zjtxAnnualOperatingConditionBO[1].id =
									res.data.AnnualOperatingCondition1;
							}
						}
					});
				}
			});
		},
		getLastThreeYears() {
			this.loading = true;
			getLastThreeYears().then(res => {
				this.loading = false;
				this.param.zjtxAnnualOperatingConditionBO[0].annual = res.data[1];
				this.param.zjtxAnnualOperatingConditionBO[1].annual = res.data[2];
			});
		},
		handleClick(tab, event) {
			this.$confirm(
				"请确认当前页数据是否填写完整并保存,否则将导致数据丢失",
				"确认离开吗?",
				{ type: "warning" }
			)
				.then(() => {
					console.log(tab.index);
					if (tab.index == 0) {
						this.$router.push("/centerform/specializationRegistration");
					} else if (tab.index == 1) {
						this.$router.push("/centerform/specializationBenefit");
					} else if (tab.index == 2) {
						this.$router.push("/centerform/specializationProfessionalization");
					} else if (tab.index == 3) {
						this.$router.push("/centerform/specializationInnovationCapacity");
					} else if (tab.index == 4) {
						this.$router.push("/centerform/specializationManagement");
					} else if (tab.index == 5) {
						this.$router.push("/centerform/specializationDatagenerated");
					}
				})
				.catch(e => {
					this.activeName = "second";
				});
		}
	}
};
</script>

<style scoped>
.text {
	border-bottom: 1px solid #dbdbdb;
	position: relative;
	padding: 10px 20px;
}

.text::before {
	content: "";
	position: absolute;
	width: 4px;
	height: 18px;
	left: 10px;
	top: 12px;
	background: #7c99fd;
}

.content {
	margin-left: 10%;
}

.content .item {
	margin-top: 15px;
	align-items: center;
}

.content .item > div {
	flex: 1;
}

.content .item > div .el-input {
	width: 50%;
}

.ruleForm {
	width: 80%;
	margin-left: 10%;
}

.ruleForm .item {
	width: 50%;
}

.ruleForm .item .el-select,
.ruleForm .item .el-input,
.ruleForm .item .el-cascader {
	width: 50%;
}

.iconfont {
	color: #d43030;
}
</style>>
